import { useState, useEffect } from 'react'
import clsx from 'clsx'
import { CDN_ENDPOINT } from '@/constants/config'

const PLACEHOLDER_SYMBOL = 'placeholder'

export default function IconToken({ symbol = '', ...props }) {
  props = {
    ...props,
    className: clsx(props.className, 'token-icon')
  }
  const [isError, setIsError] = useState(false)
  const onError = () => {
    if (isError) {
      return
    }
    setIsError(true)
  }

  useEffect(() => setIsError(false), [symbol])

  const tokenSymbol = isError ? PLACEHOLDER_SYMBOL : symbol.toLowerCase()
  const src = `${CDN_ENDPOINT}/icon/coin/coin_${tokenSymbol}.svg`
  const alt = `${tokenSymbol} token icon`

  return symbol ? (
    <img {...props} src={src} alt={alt} onError={onError} />
  ) : null
}
